import { render, staticRenderFns } from "./WingsSetStock.vue?vue&type=template&id=4b15dec4&"
import script from "./WingsSetStock.vue?vue&type=script&lang=js&"
export * from "./WingsSetStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports